/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { connect } from 'react-redux';
import PopUp from '../../Popup';
import Img from '../../Img';

import styles from './collegeRecrutingWelomePopup.scss';

class CollegeRecrutingWelomePopup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};

        this.handleSuccess = this.handleSuccess.bind(this);
    }

    handleSuccess() {
        this.props.onSuccess();
    }

    render() {
        const { auth, onCloseClick, handleClick } = this.props;
        // eslint-disable-next-line no-nested-ternary
        const minHeight = window ? (window.innerHeight > 800 ? 860 : window.innerHeight) : '100%';
        return (
            <div>
                <PopUp
                    className={`popup-md`}
                    popUpClassName={`${styles.collegeRecruitPopUp}`}
                    config={{
                        noPadding: false,
                        fullScreen: true,
                        topGradient: false,
                        scrollable: true,
                        style: {
                            height: 500,
                            maxHeight: '100%',
                            minHeight,
                        },
                    }}
                    onCloseClick={onCloseClick}
                    data-testid="modal.college-recruiting"
                >
                    <div className={`${styles.section}`}>
                        <div className={`${styles.titleSection}`}>
                            <h3 className={`text-medium`} data-testid="modal.college-recruiting.title">Welcome, {auth.user.firstName}!</h3>
                        </div>
                        <div>
                            <div className={`${styles.titleImage} flex-center`}>
                                <Img alt="Search Colleges" src="https://myutrcom.cdn.prismic.io/myutrcom/cad0fce0-9305-495e-ba41-18c372e843e3_CollegeWomenplayers.jpg" />
                            </div>
                            <div className="text-dark">
                                <span data-testid="modal.college-recruiting.what-next">{`What's next?`}</span>
                                <ul className={`${styles.whatNext}`} data-testid="modal.college-recruiting.steps-list">
                                    <li data-testid="modal.college-recruiting.step-1"><strong>Complete</strong> your UTR Sports Profile</li>
                                    <li data-testid="modal.college-recruiting.step-2"><strong>Find</strong> colleges that match your skills with UTR College Fit</li>
                                    <li data-testid="modal.college-recruiting.step-3"><strong>Follow</strong> teams to stay up to date</li>
                                    <li data-testid="modal.college-recruiting.step-4"><strong>Connect</strong> with coaches</li>
                                </ul>
                            </div>
                        </div>
                        <div className="mt32">
                            <div className={`d-flex flex-row ${styles.buttonArea}`}>
                                <div className="w-100">
                                    <button
                                        type="button"
                                        className={`w-100 btn btn-primary btn-xl font-weight-normal ${styles.pricingText}`}
                                        onClick={(e) => handleClick(e, 'next')}
                                        data-testid="modal.college-recruiting.next-btn"
                                    >
                                        Next: Complete your profile
                                    </button>
                                </div>
                            </div>
                            <div className={`text-center mt20 ${styles.footerText}`}>
                                <a className="clickable" onClick={(e) => handleClick(e, 'skip')} data-testid="modal.college-recruiting.skip-link">I'll do this later</a>
                            </div>
                        </div>
                    </div>
                </PopUp>
            </div>
        );
    }
}

const mapStateToProps = ({ auth }) => {
    return { auth };
};

export default connect(mapStateToProps)(CollegeRecrutingWelomePopup);
